export interface NormalizedMessage {
    type: string;
    payload: any;
}

const STATUS_MAP: Record<string, string> = { T: "TRADING", P: "PAUSED", D: "DELETED" };

/**
 * 将 v2 短字段 WebSocket 消息展开为标准 { type, payload } 格式。
 * 如果 data 已经有 type 字段或不匹配任何已知短字段协议，返回 null。
 */
export function normalizeShortFieldMessage( data: any ): NormalizedMessage | null {
    if ( !data || typeof data !== "object" || data.type ) {
        return null;
    }

    if ( data.t === "obs" && data.p ) {
        return normalizeOrderBookSnapshot( data.p );
    }

    if ( data.t === "mp" && data.p ) {
        return normalizeMarketPrice( data.p );
    }

    return null;
}

function normalizeOrderBookSnapshot( p: any ): NormalizedMessage {
    const yesLevels = Array.isArray( p.y )
        ? p.y.map( ( tuple: [ number, number, number? ] ) => ( {
            price: tuple[0],
            remainAmount: tuple[1],
            convertedBuyQuantity: tuple[2],
        } ) )
        : [];
    const noLevels = Array.isArray( p.n )
        ? p.n.map( ( tuple: [ number, number, number? ] ) => ( {
            price: tuple[0],
            remainAmount: tuple[1],
            convertedBuyQuantity: tuple[2],
        } ) )
        : [];

    return {
        type: "order_book_snapshot_v2",
        payload: { eventNo: p.e, guessNo: p.g, timestamp: p.ts, status: STATUS_MAP[p.s] ?? p.s, yesLevels, noLevels },
    };
}

function normalizeMarketPrice( p: any ): NormalizedMessage {
    return {
        type: "market_price",
        payload: { eventNo: p.e, guessNo: p.g, timestamp: p.ts, price: p.pr, guessType: p.gt },
    };
}
